import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Assignment } from '@material-ui/icons';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import FilterArticle from 'hooks/FilterArticle';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import TableListStock from './TableListStock';
import { wsFindBy } from 'services/WService';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
});

export default function StockLess() {
  const classes = useStyles();
  const [stockLess, setStockLess] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listStockLess(filter) {
    setDataLoading(true);
    let response = await wsFindBy('prom/stockless-bonifications', filter);
    setDataLoading(false);
    if (response.success) setStockLess(response.data);
  }

  useEffect(() => {
    listStockLess();
  }, []);

  return (
    <Card>
      <CardHeader icon>
        <CardIcon color="primary">
          <Assignment />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>Listado stocks bonificaciones {dataLoading && <LoadingSpinner />}</h4>
        
      </CardHeader>
      <CardBody>
        <FilterArticle
          getFilter={listStockLess}
          mark
          article
        />
        <TableListStock data={stockLess} show />
      </CardBody>
    </Card>
  );
}
